import {
  TimePicker,
  type TimePickerProps,
} from '@mui/x-date-pickers/TimePicker';
import { type UseControllerReturn } from 'react-hook-form';
import styles from './styles';

type Props = TimePickerProps & {
  field?: UseControllerReturn['field'];
  error?: boolean;
  helperText?: string;
};

const CustomTimePickerInput = ({
  label = 'Ώρα',
  ampm = false,
  field,
  error,
  helperText,
  ...props
}: Props) => {
  const { onBlur, ...fieldProps } = field || {};

  return (
    <TimePicker
      {...props}
      {...fieldProps}
      timezone="system"
      ampm={ampm}
      label={label}
      onClose={onBlur}
      slotProps={{
        textField: {
          sx: styles.textField,
          size: 'small',
          placeholder: 'Επιλογή',
          error,
          helperText,
          InputLabelProps: {
            shrink: true,
          },
        },
      }}
    />
  );
};

export default CustomTimePickerInput;
